"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BaseFetchPaginatedEndpoint = exports.BaseDeleteEndpoint = exports.BasePatchEndpoint = exports.BasePostEndpoint = exports.BaseGetEndpoint = exports.BaseEndpoint = void 0;
const api_1 = require("@nearD/toolkit/build/main/lib/api");
const val_1 = require("@nearD/toolkit/build/main/lib/val");
var api_2 = require("@nearD/toolkit/build/main/lib/api");
Object.defineProperty(exports, "BaseEndpoint", { enumerable: true, get: function () { return api_2.BaseEndpoint; } });
class BaseGetEndpoint extends api_1.BaseEndpoint {
    constructor() {
        super("get");
    }
}
exports.BaseGetEndpoint = BaseGetEndpoint;
class BasePostEndpoint extends api_1.BaseEndpoint {
    constructor() {
        super("post");
    }
}
exports.BasePostEndpoint = BasePostEndpoint;
class BasePatchEndpoint extends api_1.BaseEndpoint {
    constructor() {
        super("patch");
    }
}
exports.BasePatchEndpoint = BasePatchEndpoint;
class BaseDeleteEndpoint extends api_1.BaseEndpoint {
    constructor() {
        super("delete");
    }
}
exports.BaseDeleteEndpoint = BaseDeleteEndpoint;
class BaseFetchPaginatedEndpoint extends BaseGetEndpoint {
    constructor(request) {
        super();
        this.getParams = () => {
            return (0, val_1.sanitizeObject)(this.request);
        };
        this.request = request;
    }
}
exports.BaseFetchPaginatedEndpoint = BaseFetchPaginatedEndpoint;
